import React, { useEffect, useRef, useState } from "react";
import guide from "../../assets/images/guidelines.svg";
import checkStep from "../../assets/images/radio_button_checked.svg";
import warning from "../../assets/images/warning.svg";
import tick from "../../assets/images/tick.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import uploadIcon from "../../assets/images/upload.svg";
// import * as XLSX from "xlsx";
import ReactLoadingOverlay from "react-loading-overlay";
import ClipLoader from "react-spinners/ClipLoader";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import {
  FormControlLabel,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  makeStyles,
  IconButton
} from "@material-ui/core";
import { FnAuthenticatedRequest, SERVICES } from "../../Utility/Utils";
import StorageHelper from "../../Utility/StorageHelper";
import { toast } from "react-toastify";
import GuideLines from "./GuideLines";
import * as ExcelJS from 'exceljs';
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflowX: "auto",
  },
  table: {
    minWidth: 650,
    border: "none",
    [theme.breakpoints.down("sm")]: {
      overflowX: "scroll",
    },
  },
  tableContainer: {
    borderSpacing: "15px",
  },
  tableRow: {
    borderBottom: "none",
  },
  bold: {
    fontWeight: "bold",
  },
  editIcon: {
    color: "gray",
  },
  tooltip: {
    maxWidth: 350,
    fontSize: "12px",
    lineHeight: "1.6",
    padding: "10px",

    backgroundColor: "#fdecea", // light red background
    color: "#d32f2f",           // red text
    border: "1px solid #f5c2c7",
  },

  tooltipScrollable: {
    maxHeight: 200,
    overflowY: "auto",
  },

  arrow: {
    color: "#fdecea",
    "&::before": {
      backgroundColor: "#fdecea",
      border: "1px solid #f5c2c7",
    },
  },
}));

export default function BulkUploads(props) {
  const classes = useStyles();
  const { handleBack } = props;
  const [uploadedData, setUploadedData] = useState<object[]>([]);
  const [fileName, setFileName] = useState("");
  const [isTableView, setIsTableView] = useState(false);
  const [isValidated, setIsValidated] = useState(false);
  const [sortByError, setSortByError] = useState(false);
  const [unSortedData, setUnSortedData] = useState([]);
  const [erroedEntriesCount, setErroedEntriesCount] = useState(0);
  const [rightEntriesCount, setRightEntriesCount] = useState(
    uploadedData?.length
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleRemoveFile = () => {
    setFileName("");
    setUploadedData([]);
    // Reset file input value
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };
  useEffect(() => {
    if (isValidated && uploadedData) {
      let trueCounter = 0;
      let falseCounter = 0;

      uploadedData.forEach((user: any) => {
        if (user && typeof user.isValid === "boolean") {
          if (user.isValid === true) {
            trueCounter++;
          } else {
            falseCounter++;
          }
        }
      });

      setRightEntriesCount(trueCounter);
      setErroedEntriesCount(falseCounter);
    }
  }, [uploadedData, isValidated]);

  const handleSortByError = () => {
    try {
      if (isValidated) {
        let sortedData;
        if (sortByError) {
          setUploadedData(unSortedData);
        } else {
          sortedData = [...uploadedData].filter(
            (a: any) => a.isValid === false
          );
          setUploadedData(sortedData);
        }
        setSortByError(!sortByError);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const convertValuesToString = (obj) => {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] =
        key === "overrideKyc"
          ? String(obj[key] ?? "").toLowerCase() === "yes"
          : String(obj[key] ?? "");
      return acc;
    }, {});
  };


  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const contents = e.target?.result as ArrayBuffer;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(contents);
        const worksheet = workbook.worksheets[0];
        if (!worksheet) {
          toast.error("No worksheet found in the Excel file.");
          return;
        }

        // Helper function to check if a row is completely empty
        const isRowEmpty = (rowNumber: number): boolean => {
          const row = worksheet.getRow(rowNumber);
          let isEmpty = true;

          // Check each cell in the row
          for (let i = 1; i <= headers.length; i++) {
            const cellValue = getCellStringValue(row.getCell(i).value);
            if (cellValue.trim() !== "") {
              isEmpty = false;
              break;
            }
          }
          return isEmpty;
        };

        // Validation 1: Check if there are more than 1 row (including header)
        if (worksheet.rowCount <= 1) {
          toast.error("Error Found in Data: No data rows found", {
            position: toast.POSITION.TOP_CENTER,
            style: { backgroundColor: "#ff4d4f", color: "white" },
            autoClose: 3000,
            toastId: "noDataError",
          });
          resetFileInput();
          return;
        }

        const headerRow = worksheet.getRow(1);
        const rawHeaders = Array.isArray(headerRow?.values)
          ? headerRow.values.slice(1)
          : [];
        const headers: string[] = rawHeaders?.filter(Boolean)?.map((header) =>
          typeof header === "string" ? header.trim()?.toLowerCase() : String(header).trim()?.toLowerCase()
        );

        const expectedHeaders = [
          "Farmer ID",
          "Farmer Name",
          "Override KYC",
          "KYC Status",
        ];

        // Validation 3: Check if minimum 4 columns are present and collect all missing columns
        const normalizedHeaders = headers
          .map(h => h?.trim().toLowerCase())
          .filter(Boolean); // remove empty strings

        const missingColumns: string[] = [];
        if (headers?.length < 4) {
          expectedHeaders.forEach((expectedHeader, index) => {
            const normalizedExpected = expectedHeader.toLowerCase();
            if (!normalizedHeaders.includes(normalizedExpected)) {
              missingColumns.push(
                `Column ${index + 1} ${expectedHeader} is Missing`
              );
            }
          });
        }

        if (missingColumns.length > 0) {
          toast.error(`Error Found in Data: ${missingColumns.join(", ")}`, {
            position: toast.POSITION.TOP_CENTER,
            style: { backgroundColor: "#ff4d4f", color: "white" },
            autoClose: 3000,
            toastId: "missingColumnError",
          });
          resetFileInput();
          return;
        }

        // Validation 4: Check if first 4 column names match template
        for (let i = 0; i < expectedHeaders.length; i++) {
          if (headers[i] !== expectedHeaders[i]?.toLowerCase()) {
            toast.error(`Error Found in Data: Column ${i + 1} Name does not Match Template Column Name`, {
              position: toast.POSITION.TOP_CENTER,
              style: { backgroundColor: "#ff4d4f", color: "white" },
              autoClose: 3000,
              toastId: `headerMismatchError${i + 1}`,
            });
            resetFileInput();
            return;
          }
        }

        // Validation: Check if DATA rows exceed 1000 (excluding empty rows at the end)
        let dataRowCount = 0;
        for (let r = 2; r <= worksheet.rowCount; r++) {
          if (!isRowEmpty(r)) {
            dataRowCount++;
          }
        }

        if (dataRowCount > 999) { // 999 data rows + 1 header = 1000 total
          toast.error("Error Found in Data: 1000 rows exceeded", {
            position: toast.POSITION.TOP_CENTER,
            style: { backgroundColor: "#ff4d4f", color: "white" },
            autoClose: 1000,
            toastId: "rowLimitError",
          });
          resetFileInput();
          return;
        }



        // Find the last non-empty row in the dataset (to handle empty rows at the end)
        let lastDataRow = 1; // Start with header row
        for (let r = worksheet.rowCount; r >= 2; r--) {
          if (!isRowEmpty(r)) {
            lastDataRow = r;
            break;
          }
        }

        // Now validate only rows up to lastDataRow (skip empty rows at the end)

        // Validation 5: Ensure Farmer ID and Farmer Name are not blank on any NON-EMPTY data row
        const farmerIdColIndex = headers.indexOf("farmer id");
        const farmerNameColIndex = headers.indexOf("farmer name");

        if (farmerIdColIndex !== -1 && farmerNameColIndex !== -1) {
          for (let r = 2; r <= lastDataRow; r++) {
            // Check if row is completely empty - this should be an error for in-between rows
            if (isRowEmpty(r)) {
              toast.error(`Error Found in Data: Row ${r} has missing / blank data`, {
                position: toast.POSITION.TOP_CENTER,
                style: { backgroundColor: "#ff4d4f", color: "white" },
                autoClose: 3000,
              });
              resetFileInput();
              return;
            }

            const idCell = worksheet.getRow(r).getCell(farmerIdColIndex + 1);
            const nameCell = worksheet.getRow(r).getCell(farmerNameColIndex + 1);
            const idRaw = getCellStringValue(idCell.value).trim();
            const nameRaw = getCellStringValue(nameCell.value).trim();

            if (idRaw === "" || nameRaw === "") {
              toast.error(`Error Found in Data: Row ${r} has missing / blank data`, {
                position: toast.POSITION.TOP_CENTER,
                style: { backgroundColor: "#ff4d4f", color: "white" },
                autoClose: 3000,
              });
              resetFileInput();
              return;
            }
          }
        }

        // Validation 6: Override KYC column values (only allow Yes / No)
        const overrideColIndex = headers.indexOf("override kyc");
        if (overrideColIndex !== -1) {
          let firstInvalidRow: number | null = null;
          for (let r = 2; r <= lastDataRow; r++) {
            // Skip validation for completely empty rows (these were already caught above)
            if (isRowEmpty(r)) continue;

            const cell = worksheet.getRow(r).getCell(overrideColIndex + 1);
            const raw = getCellStringValue(cell.value).trim();
            const low = raw.toLowerCase();
            if (raw === "" || (low !== "yes" && low !== "no")) {
              firstInvalidRow = r;
              break;
            }
          }

          if (firstInvalidRow !== null) {
            const colNumber = overrideColIndex + 1; // 1-based column index
            toast.error(
              `Error Found in Data: Row ${firstInvalidRow}, Column ${colNumber}, data is not in required format`,
              {
                position: toast.POSITION.TOP_CENTER,
                style: { backgroundColor: "#ff4d4f", color: "white" },
                autoClose: 6000,
              }
            );
            resetFileInput();
            return;
          }
        }

        // Validation 7: KYC Status only when Override KYC is Yes: require Open / Not Open
        const statusColIndex = headers.indexOf("kyc status");
        if (statusColIndex !== -1) {
          let firstInvalidStatusRow: number | null = null;
          for (let r = 2; r <= lastDataRow; r++) {
            // Skip validation for completely empty rows (these were already caught above)
            if (isRowEmpty(r)) continue;

            const overrideCell = worksheet.getRow(r).getCell(overrideColIndex + 1);
            const overrideRaw = getCellStringValue(overrideCell.value).trim().toLowerCase();

            if (overrideRaw === "yes") {
              const statusCell = worksheet.getRow(r).getCell(statusColIndex + 1);
              const statusRaw = getCellStringValue(statusCell.value).trim();
              const statusLow = statusRaw.toLowerCase();
              if (!(statusLow === "open" || statusLow === "not open")) {
                firstInvalidStatusRow = r;
                break;
              }
            }
          }

          if (firstInvalidStatusRow !== null) {
            const colNumber = statusColIndex + 1;
            toast.error(
              `Error Found in Data: Row ${firstInvalidStatusRow}, Column ${colNumber}, data is not in required format`,
              {
                position: toast.POSITION.TOP_CENTER,
                style: { backgroundColor: "#ff4d4f", color: "white" },
                autoClose: 6000,
              }
            );
            resetFileInput();
            return;
          }
        }

        // Process data if all validations pass
        const data: any[] = [];
        for (let i = 2; i <= lastDataRow; i++) {
          // Skip completely empty rows during processing (these were already validated above)
          if (isRowEmpty(i)) continue;

          const row = worksheet.getRow(i);
          const rowData: Record<string, any> = {};

          headers.forEach((header, index) => {
            const cell = row.getCell(index + 1);
            rowData[header] = getCellStringValue(cell.value);
          });

          const hasData = Object.values(rowData).some(val => String(val).trim() !== "");
          if (hasData) data.push(rowData);
        }

        const arrUploadedData = data.map((v: any) => {
          const getValue = (key: string) => v[key] ?? "";

          const userObject = {
            farmerId: getValue("farmer id"),
            farmerName: getValue("farmer name"),
            overrideKyc: getValue("override kyc"),
            kycStatus: getValue("kyc status"),
          };
          return convertValuesToString(userObject);
        });

        if (arrUploadedData.length > 0) {
          setUploadedData(arrUploadedData);
          setFileName(file.name);
        } else {
          toast.error("Error Found in Data: No data rows found", {
            position: toast.POSITION.TOP_CENTER,
            style: { backgroundColor: "#ff4d4f", color: "white" },
            autoClose: 3000,
            toastId: "noValidDataError",
          });
          resetFileInput();
        }

      } catch (error) {
        console.error("Error parsing file:", error);
        toast.error("Error reading file. Please ensure it's a valid Excel file.", {
          position: toast.POSITION.TOP_CENTER,
          style: { backgroundColor: "#ff4d4f", color: "white" },
          autoClose: 3000,
        });
        resetFileInput();
      }
    };

    reader.onerror = () => {
      console.error("Failed to read the file.");
      toast.error("Failed to read the file. Please try again.", {
        position: toast.POSITION.TOP_CENTER,
        style: { backgroundColor: "#ff4d4f", color: "white" },
        autoClose: 3000,
      });
      resetFileInput();
    };

    reader.readAsArrayBuffer(file);
  };

  // Helper function to reset file input
  const resetFileInput = () => {
    const fileInput = document.getElementById("fileInput") as HTMLInputElement;
    if (fileInput) fileInput.value = "";
  };

  // Helper function to handle cell value conversion
  function getCellStringValue(value: any): string {
    if (value === null || value === undefined) return "";

    // Handle cases where value is a rich text object
    if (typeof value === "object") {
      // If it's a rich text object, return the text content
      if (value.richText && Array.isArray(value.richText)) {
        return value.richText.map((item: any) => item.text).join(""); // Extract text from rich text array and join if multiple parts
      }

      // If it's a Date object, convert it to ISO string
      if (value instanceof Date) return value.toISOString();

      // For any other object (array or complex object), just return empty string
      return "";
    }

    // For other cases, simply convert to string and trim
    return String(value).trim();
  }


  const handleSubmit = async (data) => {
    try {
      if (!Array.isArray(data)) {
        throw new Error("Data is not an array");
      }
      setIsLoading(true)
      let authData = JSON.parse(StorageHelper.get("auth") || "{}");
      const authHeader = {
        JWTToken: authData.jwtToken,
        userId: authData.userId,
      };

      const inputData = data
        .filter((user) => user && user.isValid)
        .map((user) => {
          return {
            farmerId: user?.farmerId,
            // farmerName: user?.farmerName,
            isKycOverrideEnabled: user?.overrideKyc,
            isKycStatusEnable: user?.kycStatus,
          };
        });

      const payload = inputData;
      const response: any = await FnAuthenticatedRequest(
        "POST",
        "KycOverride/BulkUpload",
        authHeader,
        payload,
        SERVICES.KYC
      );

      if (response?.success) {
        const entryCount = payload?.length;
        const message = `✓ ${entryCount} Entry Import${entryCount !== 1 ? "s" : ""
          } Successfully`;
        toast.success(message, {
          position: toast.POSITION.TOP_CENTER,
          style: {
            backgroundColor: "#258750",
            color: "white",
          },
          autoClose: 3000,
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        setIsLoading(false)
        toast.success(response?.error, {
          position: toast.POSITION.TOP_CENTER,
          style: {
            backgroundColor: "#ff4d4d",
            color: "white",
          },
          autoClose: 3000,
        });
      }
    } catch (error) {
      setIsLoading(false)
      console.error(error);
    }
  };

  const handleValidate = async () => {
    try {
      if (uploadedData?.length !== 0) {
        setIsLoading(true);
        let authData = JSON.parse(StorageHelper.get("auth") || "{}");
        const authHeader = {
          JWTToken: authData.jwtToken,
          userId: authData.userId,
        };
        const modifiedPayload = uploadedData?.map((user: any) => {
          const { overrideKyc, kycStatus, ...rest } = user;
          return {
            ...rest,
            kycOverride: overrideKyc,
            kycStatus: overrideKyc ? kycStatus?.toLowerCase() === "open" : false
          }
        })
        const payload = modifiedPayload;
        const response: any = await FnAuthenticatedRequest(
          "POST",
          "KycOverride/ValidateOverrideKyc",
          authHeader,
          payload,
          SERVICES.KYC
        );

        if (response?.success) {
          setIsLoading(false);
          setUploadedData(response?.data);
          setUnSortedData(response?.data);
          setIsValidated(true);
        } else {
          setIsLoading(false);
          toast.success(response?.error, {
            position: toast.POSITION.TOP_CENTER,
            style: {
              backgroundColor: "#ff4d4d",
              color: "white",
            },
            autoClose: 3000,
          });
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const handleNext = () => {
    try {
      if (uploadedData?.length !== 0) {
        handleValidate();
        setIsTableView(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlePrev = () => {
    try {
      setIsTableView(false);
      setFileName("");
      setUploadedData([]);
      setSortByError(false)
    } catch (error) {
      console.error(error);
    }
  };

  const toggleGuide = () => {
    setIsModalOpen((prevState) => !prevState);
  };

  const generateErrorFilename = () => {
    try {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const formattedDate = `${year}${month}${day}`;
      const filename = `ErrorData_Bulk_Upload_Ka_${formattedDate}`;
      return filename;
    } catch (error) {
      console.error(error);
    }
  };

  const downloadErrorData = (data) => {
    try {
      const errorData = data
        .filter((user) => user && !user.isValid)
        .map((user) => {
          return {
            Name: user?.name,
            "Mobile Number": user?.mobile,
            Role: user?.role,
            "Reporting Manager Mobile Number": user?.reportingManager,
            "Partner Name": user?.partnerName,
            "Zone (Mandatory for ZBM, RBM,TBM,KA)": user?.zone,
            "State (Mandatory for KA,RBM,TBM)": user?.state,
            "Territory (Mandatory for TBM,KA)": user?.territory,
            "District (Mandatory for KA)": user?.district,
            "Joining Date (DD-MM-YYYY)": user?.joinedDate,
            "Test User (Yes or No)(In case of empty by default No will be selected)":
              user?.isTestUser,
          };
        });
      const fileName = generateErrorFilename();
      console.log(errorData);
      // downloadExcel(errorData, fileName);
    } catch (error) {
      console.error(error);
    }
  };

  const fnJoinedDate = (joinedDate) => {
    const parsedDate = Date.parse(joinedDate);
    if (isNaN(parsedDate)) {
      return <div>Invalid date</div>;
    }
    const date = new Date(parsedDate);
    date.setUTCHours(0, 0, 0, 0);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    return <div>{formattedDate}</div>;
  };

  return (
    <>
      {isLoading === false ? (
        <div className="px-5">
          <div className="block sm:flex items-center">
            <ArrowBackIcon
              className="cursor-pointer transition-all hover:text-[#009CA7] active:text-[#007a80]"
              onClick={handleBack}
            />
            <h1 className="text-2xl mt-1 font-bold px-3 py-3">Bulk Upload</h1>
            <img
              src={guide}
              className="ml-auto mr-12 cursor-pointer"
              alt="guide"
              onClick={toggleGuide}
            />
            <GuideLines isOpen={isModalOpen} onClose={toggleGuide} />
          </div>
          <hr className="mt-1 border border-gray-200" />
          <div className="mt-2">
            <div className="flex justify-center items-center">
              <div className="flex flex-col items-center">
                <p
                  className={`flex w-6 h-6 rounded-full items-center justify-center mr-0 bg-[#009CA7] text-white`}
                >
                  {isTableView === false ? (
                    <>1</>
                  ) : (
                    <img src={checkStep} alt="step1" />
                  )}
                </p>
                <p>Upload</p>
              </div>
              <hr
                className={`w-56 border-2 border-t ${!isTableView ? `border-gray-300` : `border-[#009CA7]`
                  }  -mt-6 -mx-3.5`}
              />
              <div className="flex flex-col items-center">
                <p
                  className={`flex w-6 h-6 rounded-full items-center justify-center mr-0 ${isTableView
                    ? `bg-[#009CA7] text-white`
                    : `bg-gray-300 text-gray-400`
                    } `}
                >
                  2
                </p>
                <p>View</p>
              </div>
            </div>
          </div>
          {isTableView === true ? (
            <div>
              <div className="flex pb-2">
                <p className="text-sm py-1">
                  Showing {uploadedData?.length} entries
                </p>
                <div className="ml-auto -my-1">
                  <FormControlLabel
                    style={{
                      color: "#666666",
                      fontFamily: "Open Sans",
                      fontSize: "14px",
                    }}
                    control={
                      <Switch
                        color="primary"
                        checked={sortByError}
                        onChange={handleSortByError}
                      />
                    }
                    label=" Only show rows with errors"
                  />
                </div>
              </div>
              <div className="bg-white p-3">
                <div className="flex gap-2">

                  {isValidated && (
                    <>
                      <span className="h-7"></span>
                      {erroedEntriesCount > 0 && (
                        <div className="font-bold py-3">
                          <span className="flex flex-row">
                            <img src={warning} alt="tick" />{" "}
                            <p className="text-[#FF0000] px-1">
                              {erroedEntriesCount}{" "}
                              {erroedEntriesCount === 1 ? "Entry" : "Entries"}
                            </p>
                            {`contains error, fix error before you import.`}
                          </span>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <hr className="border border-gray-300" />
                <TableContainer component={Paper} className="mt-3 h-80">
                  <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                      <TableRow className="bg-[#E5F5F6] text-nowrap">
                        <TableCell className={classes.bold}>Farmer ID</TableCell>
                        <TableCell className={classes.bold}>Farmer Name</TableCell>
                        <TableCell className={classes.bold}>Override KYC</TableCell>
                        <TableCell className={classes.bold}>
                          KYC Status
                        </TableCell>
                        <TableCell className={classes.bold}>
                          {" "}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {uploadedData?.map((user: any, index) => {
                        const errorMessages = user?.validationObject?.errorMessages || [];
                        const enableScroll = errorMessages.length > 3;
                        return (
                          <TableRow
                            key={index}
                            className="border-0 text-nowrap"
                          >
                            <TableCell
                              className={`${user?.validationObject?.farmerId === false &&
                                `bg-red-500`
                                }`}
                            >
                              {user?.farmerId}
                            </TableCell>
                            <TableCell
                              className={`${user?.validationObject?.farmerName === false &&
                                `bg-red-500`
                                }`}
                            >
                              {user?.farmerName}
                            </TableCell>
                            <TableCell
                              className={`${user?.validationObject?.overrideKyc === false &&
                                `bg-red-500`
                                }`}
                            >
                              {user?.overrideKyc ? "Yes" : "No"}
                            </TableCell>
                            <TableCell
                              className={`${user?.validationObject?.kycStatus ===
                                false && `bg-red-500`
                                }`}
                            >
                              {user?.overrideKyc ? user?.kycStatus ? "Open" : "Not Open" : "-"}
                            </TableCell>
                            <TableCell>
                              {errorMessages.length > 0 && (
                                <Tooltip
                                  title={
                                    <div>
                                      {errorMessages.map((msg, index) => (
                                        <div key={index} style={{ marginTop: index === 0 ? 0 : 8, color: "red" }}>
                                          <strong>{index + 1}.</strong> {msg}
                                        </div>
                                      ))}
                                    </div>
                                  }
                                  placement="top"
                                  arrow
                                  interactive
                                  classes={{
                                    tooltip: `${classes.tooltip} ${enableScroll ? classes.tooltipScrollable : ""
                                      }`,
                                    arrow: classes.arrow,
                                  }}
                                >
                                  <span>
                                    <IconButton size="small">
                                      <InfoOutlinedIcon fontSize="small" style={{ color: "red", zIndex: 1 }} />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              )}
                            </TableCell>

                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          ) : (
            <>
              <div className="mt-10">
                <div className="flex justify-center mt-0">
                  <div
                    className={`border-2 border-dashed border-opacity-50 border-gray-400 ${uploadedData?.length === 0 ? `bg-white` : `bg-green-300`
                      } flex flex-col justify-center items-center px-28 py-12`}
                  >
                    <input
                      type="file"
                      ref={fileInputRef}
                      id="fileInput"
                      accept=".csv, .xlsx"
                      className="hidden"
                      onChange={handleFileUpload}
                    />
                    <img
                      src={uploadIcon}
                      alt="Bulk Upload Img"
                      className="cursor-pointer"
                      onClick={() =>
                        document.getElementById("fileInput")?.click()
                      }
                    />
                    {fileName !== "" && (
                      <div>
                        <span className="text-wrap w-2">{fileName}</span>
                        <span
                          className="cursor-pointer text-2xl text-red-500 ml-2"
                          onClick={handleRemoveFile}
                        >
                          x
                        </span>
                      </div>
                    )}

                    <p
                      className="text-[#009CA7] cursor-pointer font-semibold mt-4 text-base"
                      onClick={() =>
                        document.getElementById("fileInput")?.click()
                      }
                    >
                      {uploadedData?.length === 0
                        ? "Upload File"
                        : "Replace File"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex justify-center items-center mt-7">
                <h1 className="text-base">
                  Use csv format, or{" "}
                  <a
                    // href="/soil_sampling_template.xlsx"
                    href="/Kyc Override Template.xlsx"
                    className="text-[#009CA7] font-bold"
                    download
                  >
                    Download Template
                  </a>
                </h1>
              </div>
            </>
          )}

          <div className="flex fixed bottom-2 left-16 right-0 justify-center items-center gap-10 sm:gap-96">
            <button
              className="flex px-6 py-1.5 border-2 border-grey-300 rounded-md bg-white mr-4"
              onClick={handleBack}
            >
              Cancel
            </button>
            {isTableView ? (
              <div className="flex gap-3">
                <button
                  className={`flex px-8 py-1.5 border-2 border-grey-300 rounded-md text-dark bg-white`}
                  onClick={handlePrev}
                >
                  Prev
                </button>
                <button
                  className={`flex px-8 py-1.5 border-2 border-grey-300 rounded-md text-white ${(uploadedData?.length === 0 ||
                    erroedEntriesCount > 0) &&
                    isValidated
                    ? `bg-gray-400`
                    : `bg-[#009CA7]`
                    } `}
                  disabled={
                    (uploadedData?.length === 0 ||
                      erroedEntriesCount > 0) && isValidated
                  }
                  onClick={() => {
                    if (isValidated) {
                      handleSubmit(uploadedData);
                    } else {
                      handleValidate();
                    }
                  }}
                >
                  {isValidated === true ? `Import` : `Validate`}
                </button>
              </div>
            ) : (
              <button
                className={`flex px-8 py-1.5 border-2 border-grey-300 rounded-md text-white ${uploadedData?.length === 0 ? `bg-gray-400` : `bg-[#009CA7]`
                  } `}
                onClick={handleNext}
              >
                Next
              </button>
            )}
          </div>
        </div>
      ) : (
        <ReactLoadingOverlay
          classNamePrefix="growindigo_"
          active={true}
          spinner={<ClipLoader color="#27878E" />}
          text={""}
        ></ReactLoadingOverlay>
      )}
    </>
  );
}
